import { render, staticRenderFns } from "./ItemMeasureUnitList.vue?vue&type=template&id=839b576a"
import script from "./ItemMeasureUnitList.vue?vue&type=script&lang=js"
export * from "./ItemMeasureUnitList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports